<template>
  <footer id="link_ancor__contact">
    <div class="sky">
      <!-- The heavens declare the glory of Jesus -->
      <span class="sky__container" v-if="footerVisible">
        <video class="sky__background" v-if="footerVideo" src="/inicio/black/bluesky_2.mp4" width="500px" height="500px" autoplay loop muted playsinline></video>
        <img class="sky__background--white" v-else src="/inicio/black/footer__mobile.jpg" alt="sky" loading="lazy">
        <div class="sky__shadows" id="shadow"></div>
      </span>
      <span class="sky__container" v-else>
        <img class="sky__background--white" src="/inicio/white/footer.jpg" alt="sky" loading="lazy">
        <div class="sky__shadows--white" id="shadow"></div>
      </span>
      <!-- Infos -->
      <div class="sky__informations" style="backdrop-filter: blur(0px);">
        <div class="information__container">
          <address class="information__content">
            <div class="contacts__column">
              <a
                class="decoration"
                @mouseenter="blurIn('enter')"
                @mouseleave="blurIn"
                href="https://www.linkedin.com/in/mateus-duraes-dos-santos/"
                target="_blank"
              >
                <div class="information__contato">
                  <img :src="`/icons/${iconsTheme}/linkedin.svg`" alt="Logo LinkedIn" loading="lazy">
                  <p class=" contato__email">Linkedin</p>
                </div>
                <div class="decoration__info">Mateus Durães dos Santos</div>
                <img class="decoration__copy" :src="`/icons/${iconsTheme}/link.svg`" alt="Copy icon" loading="lazy">
              </a>
            </div>
          </address>
          <div id="observador__footer" style="height: 200px; display: flex; align-items: flex-end; position: absolute; bottom: 0;">
            <p class="phrase">Who said footers have to be boring?</p>
          </div>
        </div>
      </div>

      <img v-for="i in 14" :key="i" :class="`sky__planet_${i} sky__planet`" :src="`/inicio/${whiteImages}/planet_${i}.webp`" alt="" loading="lazy">
      <img class="sky__smile sky__planet" :src="`/inicio/${whiteImages}/smile.svg`" alt="" loading="lazy">
    </div>
  </footer>
</template>

<script>
export default {
  data() {
      return {
          iconsTheme: 'whiteicons',
          footerVideo: Boolean,
          success: false,
          error: false,
          nome: '',
          email: '',
          message: '',
      }
  },
  props: {
      whiteImages: String,
      blockClicked: String,
      footerVisible: Boolean,
  },
  mounted() {
    this.observador()
    if (window.screen.availWidth < 1000) {
      this.footerVideo = false
    }
  },
  beforeUnmount() {
    this.footerObserver?.disconnect()
    clearTimeout(this.blurTimeout)
    document.getElementById('header')?.classList.remove('hiddenHeader')
  },
  watch: {
    blockClicked(){
      this.iconsTheme = this.blockClicked
    }
  },
  methods: {
    blurIn(enter) {
      clearTimeout(this.blurTimeout)
      const footer = document.querySelector('.sky__informations')
      let blur = Number(footer.style.backdropFilter.split('(')[1][0])
      let y = blur
      const addBlur = (increment) => {
        footer.setAttribute('style', `backdrop-filter: blur(${y}px)`);
        y += increment
        if ((increment === 1 && y < 10) || (increment === -1 && y >= 0)) {
          clearTimeout(this.blurTimeout)
          this.blurTimeout = setTimeout(() => addBlur(increment), 20);
        }
      }
      addBlur(enter == 'enter' ? 1 : -1)
      
      const open = document.getElementById('link_ancor__contact')
      open.classList[enter == 'enter' ? 'add': 'remove']('open')
    },
    
    copyText(content) {
      // Only works when online, HTTPS is required for security        
      if (!navigator.clipboard) {
        console.error('Clipboard API not available');
        alert('Copying not supported in this browser');
        return;
      }
      navigator.clipboard.writeText(content)
      .then(() => alert("Copied text: " + content))
    },
    
    observador() { // Change header style when user reaches the footer
      const header = document.getElementById('header')
      const observer = new IntersectionObserver(entries => {
        this.$emit('nomeEvento', entries[0].isIntersecting)

        if (entries[0].isIntersecting) header.classList.add('hiddenHeader') 
        else header.classList.remove('hiddenHeader')
      
      })
      this.footerObserver = observer
      observer.observe(document.getElementById('observador__footer'))
    },
  },
}
</script>

<style>
:root {
  --shadow-color: black;
  --sky-scale: 0.9;
}

.contato__email {
  padding-right: 10px;
  font-size: 20px;
  font-weight: 600;
}

.sky {
  position: relative;
  overflow: hidden;
  height: 100vh;
  width: 100vw;
  z-index: 2;
}

footer {
  position: relative;
}

footer.open * {
  transition: 1.3s;
}

.whiteTheme footer::before {
  position: absolute;
  content: '';
  background-image: linear-gradient(transparent, var(--body_color));
  bottom: 100%;
  height: 400px;
  width: 100%;
  pointer-events: none;
  z-index: 1;
}

.sky__overlay--open {
    opacity: 1;
    pointer-events: initial;
}

.sky__forms {
  display: flex;
  flex-direction: column;
  width: 300px;
  gap: 10px;
}

.whiteTheme .sky__informations::after {
  position: absolute;
  content: '';
  top: 0;
  width: 100vw;
  background-image: linear-gradient(var(--body_color), transparent);
  height: 200px;
  z-index: 2;
}

.sky__informations::before {
  position: absolute;
  content: '';
  bottom: 100%;
  width: 100vw;
  height: 200px;
  z-index: 2;
  background-image: linear-gradient(transparent, black);
}

.sky__container {
  display: flex;
  flex-direction: column;
}

.sky__shadows,
.sky__shadows--white {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  transition: .2s;
}

.sky__shadows {
  background-image: radial-gradient(transparent, transparent, var(--shadow-color), var(--shadow-color));
}

.sky__shadows--white {
  background-image: linear-gradient(#E9DFDF, transparent);
  height: 30vh;
}

.sky__background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sky__background--white {
  width: 100%;
  height: 100vh;
  object-fit: cover;
}

.sky__informations {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  z-index: 4;
}

.information__container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  margin: auto;
  width: calc(100% - 200px);
  padding: 40px 0;
}

.contacts__column {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 100px;
}

.decoration {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  width: max-content;
}

.decoration:hover .decoration__copy {
  opacity: 1;
  width: 30px;
}

.decoration__copy {
  position: absolute;
  right: -28px;
  opacity: 0;
  width: 0;
  cursor: pointer;
  transition: .2s;
}

.decoration__copy:hover {
  opacity: 0.6;
  transition: .2s;
}

.decoration__info {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-align: center;
  bottom: -40px;
  height: 40px;
  opacity: 0;
  border-radius: 10vw;
  transition: .2s;
  font-size: 18px;
}

.decoration:hover .decoration__info {
  opacity: 1;
  transition: .2s;
}

.information__contato {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  cursor: pointer;
  gap: 20px;
}

.information__contato img {
  width: 34px;
  height: 34px;
  margin-top: 3px;
}

.information__content {
  display: flex;
  justify-content: center;
  gap: 4vw;
  width: max-content;
  margin: auto;
}

.phrase {
  color: #9aa3b2;
  font-weight: 400;
  text-align: center;
  margin-bottom: 20px;
}

.smile_cont {
  position: absolute;
  left: 18%;
  bottom: 0;
  width: 22%;
  animation-name: sky_11;
}

.sky__planet {
  position: absolute;
  animation-duration: 12s;
  animation-iteration-count: infinite;
  z-index: 2;
}

.sky__planet_1, .sky__planet_2, .sky__planet_3, .sky__planet_4, .sky__planet_5, .sky__planet_6, .sky__planet_7, .sky__planet_8, .sky__planet_9, .sky__planet_10, .sky__planet_11, .sky__planet_12, .sky__planet_13, .sky__planet_14, .sky__smile {
  transition: 2s;
}

.sky__smile {
  left: 40%;
  width: 7%;
  bottom: 16%;
  animation-name: sky_11;
}

.sky__planet_1 {
  width: 11%;
  left: 6%;
  top: 14%;
  animation-name: sky_04;
}

.sky__planet_2 {
  width: 13%;
  bottom: 4%;
  right: 32vw;
  animation-name: sky_01;
}

.sky__planet_3 {
  width: 16%;
  top: 6%;
  left: 28%;
  animation-name: sky_02;
}

.sky__planet_5 {
  top: 38%;
  right: 30%;
  width: 13%;
  animation-name: sky_02;
}

.sky__planet_6 {
  bottom: 25%;
  width: 24%;
  right: 10%;
  animation-name: sky_08;
}

.sky__planet_7 {
  width: 7.5%;
  top: 21%;
  right: 37%;
  animation-name: sky_11;
}

.sky__planet_8 {
  width: 15%;
  top: 17%;
  left: 30%;
  animation-name: sky_08;
}

.sky__planet_9 {
  animation-name: sky_01;
  top: 40%;
  left: 20%;
  width: 9%;
}

.sky__planet_10 {
  width: 17%;
  bottom: 30%;
  left: 26%;
  z-index: 3;
  animation-name: sky_04;
}

.sky__planet_11 {
  width: 24%;
  z-index: 2;
  bottom: -14vh;
  left: 20%;
  bottom: -10%;
  animation-name: sky_11;
}

.sky__planet_12 {
  width: 28%;
  right: 10%;
  top: 0;
  z-index: 1;
  animation-name: sky_08;
}

.sky__planet_13 {
  left: 0;
  width: 15%;
  bottom: 30%;
  animation-name: sky_y;
}

.sky__planet_14 {
  width: 6%;
  right: 0;
  bottom: 45%;
  animation-name: sky_13;
}

@keyframes sky_01 {
  0% { transform: scale(var(--sky-scale)) translate(0, 0) }
  20% { transform: scale(var(--sky-scale)) translate(0, 0) }
  45% { transform: scale(var(--sky-scale)) translate(-30px, -40px) }
  75% { transform: scale(var(--sky-scale)) translate(10px, -60px) }
  100% { transform: scale(var(--sky-scale)) translate(0, 0) }
}

@keyframes sky_02 {
  0% { transform: scale(var(--sky-scale)) translate(0, 0) }
  15% { transform: scale(var(--sky-scale)) translate(-60px, 0) }
  35% { transform: scale(var(--sky-scale)) translate(-60px, -20px) }
  75% { transform: scale(var(--sky-scale)) translate(-60px, 20px) }
  100% { transform: scale(var(--sky-scale)) translate(0, 0) }
}

@keyframes sky_04 {
  0% { transform: scale(var(--sky-scale)) translate(0, 0) }
  50% { transform: scale(var(--sky-scale)) translate(30px, 40px) }
  100% { transform: scale(var(--sky-scale)) translate(0, 0) }
}

@keyframes sky_08 {
  0% { transform: scale(var(--sky-scale)) translate(0, 0) }
  35% { transform: scale(var(--sky-scale)) translate(20px, 50px) }
  70% { transform: scale(var(--sky-scale)) translate(-35px, 60px) }
  100% { transform: scale(var(--sky-scale)) translate(0, 0) }
}

@keyframes sky_11 {
  0% { transform: scale(var(--sky-scale)) translate(0, 0) }
  50% { transform: scale(var(--sky-scale)) translate(20px, 0) }
  75% { transform: scale(var(--sky-scale)) translate(0px, -30px) }
  90% { transform: scale(var(--sky-scale)) translate(20px, 0) }
  100% { transform: scale(var(--sky-scale)) translate(0, 0) }
}

@keyframes sky_13 {
  0% { transform: scale(var(--sky-scale)) translatey(0) }
  10% { transform: scale(var(--sky-scale)) translatey(0) }
  35% { transform: scale(var(--sky-scale)) translatey(60px) }
  90% { transform: scale(var(--sky-scale)) translatey(0) }
  100% { transform: scale(var(--sky-scale)) translatey(0) }
}

@keyframes sky_y {
  0% { transform: translatey(0) }
  50% { transform: translatey(60px) }
  100% { transform: translatey(0) }
}

@media screen and (max-width: 1000px) {

  :root {
    --sky-scale: 1.4
  }

  @keyframes sky_01 {
    0% { transform: scale(var(--sky-scale)) translate(0, 0) }
    20% { transform: scale(var(--sky-scale)) translate(0, 0) }
    45% { transform: scale(var(--sky-scale)) translate(-30px, -40px) }
    75% { transform: scale(var(--sky-scale)) translate(10px, -60px) }
    100% { transform: scale(var(--sky-scale)) translate(0, 0) }
  }

  @keyframes sky_02 {
    0% { transform: scale(var(--sky-scale)) translate(0, 0) }
    15% { transform: scale(var(--sky-scale)) translate(-60px, 0) }
    35% { transform: scale(var(--sky-scale)) translate(-60px, -20px) }
    75% { transform: scale(var(--sky-scale)) translate(-60px, 20px) }
    100% { transform: scale(var(--sky-scale)) translate(0, 0) }
  }

  @keyframes sky_04 {
    0% { transform: scale(var(--sky-scale)) translate(0, 0) }
    50% { transform: scale(var(--sky-scale)) translate(30px, 40px) }
    100% { transform: scale(var(--sky-scale)) translate(0, 0) }
  }

  @keyframes sky_08 {
    0% { transform: scale(var(--sky-scale)) translate(0, 0) }
    35% { transform: scale(var(--sky-scale)) translate(20px, 50px) }
    70% { transform: scale(var(--sky-scale)) translate(-35px, 60px) }
    100% { transform: scale(var(--sky-scale)) translate(0, 0) }
  }

  @keyframes sky_11 {
    0% { transform: scale(var(--sky-scale)) translate(0, 0) }
    50% { transform: scale(var(--sky-scale)) translate(20px, 0) }
    75% { transform: scale(var(--sky-scale)) translate(0px, -30px) }
    90% { transform: scale(var(--sky-scale)) translate(20px, 0) }
    100% { transform: scale(var(--sky-scale)) translate(0, 0) }
  }

  @keyframes sky_13 {
    0% { transform: scale(var(--sky-scale)) translatey(0) }
    10% { transform: scale(var(--sky-scale)) translatey(0) }
    35% { transform: scale(var(--sky-scale)) translatey(60px) }
    90% { transform: scale(var(--sky-scale)) translatey(0) }
    100% { transform: scale(var(--sky-scale)) translatey(0) }
  }

  .information__content {
    gap: 20px;
  }

  .contacts__column {
    flex-direction: column;
  }

  .information__container {
    width: 100%;
    gap: 0;
    padding: 140px 0;
  }

  .information__contato img {
    width: 30px;
  }

  .phrase {
    font-size: max(12px, 0.8rem);
  }

  .information__contato {
    gap: 6px;
    font-size: 16px;
  }

  :root {
    --sky-scale: 1
  }
}

@media only screen and (max-width: 500px) {
  .decoration__info, .decoration__copy {
    display: none;
  }
}

.whiteTheme .sky__informations {
  mix-blend-mode: inherit;
}

.whiteTheme .contato__email, .whiteTheme .decoration__info {
  color: black;
}

.open .sky__planet_1 {
  left: 10%;
  top: 8%;
}

.open .sky__planet_2 {
  bottom: 0%;
  right: 27vw;
}

.open .sky__planet_3 {
  top: 0%;
  left: 25%;
}

.open .sky__planet_5 {
  top: 18%;
  right: 1%;
}

.open .sky__planet_6 {
  bottom: 24%;
  right: 1%;
}

.open .sky__planet_7 {
  top: 4%;
  right: 44%;
}

.open .sky__planet_8 {
  top: -10%;
  left: 32%;
}

.open .sky__planet_9 {
  top: 27%;
  left: 7%;
}

.open .sky__planet_10 {
  bottom: -8%;
  left: 34%;
}

.open .sky__planet_11 {
  bottom: 4vh;
  left: 8%;
}

.open .sky__planet_12 {
  right: 12%;
  top: -10%;
}

.open .sky__planet_13 {
  left: 0;
  bottom: 30%;
}

.open .sky__planet_14 {
  right: 0;
  bottom: 45%;
}

@media screen and (max-width: 700px) {
  .sky {
    height: 100svh;
    min-height: 640px;
    width: 100%;
  }

  .sky__background--white {
    height: 100%;
    position: absolute;
    inset: 0;
  }

  .information__container {
    box-sizing: border-box;
    width: 100%;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: 1fr auto;
    justify-content: stretch;
    justify-items: center;
    gap: 24px;
    padding: 100px 24px max(36px, env(safe-area-inset-bottom));
  }

  .information__content {
    position: static;
    grid-row: 1;
    align-self: center;
    width: 100%;
    margin: 0;
  }

  .decoration {
    min-height: 64px;
  }

  .information__contato {
    gap: 12px;
  }

  .information__contato img {
    width: 36px;
    height: 36px;
    margin: 0;
  }

  .contato__email {
    font-size: clamp(26px, 7vw, 34px);
    padding: 0;
  }

  .decoration__info,
  .decoration__copy {
    display: none;
  }

  #observador__footer {
    grid-row: 2;
    position: static !important;
    height: auto !important;
    display: flex !important;
    flex-direction: column;
    align-items: center !important;
    gap: 20px;
    width: 100%;
    max-width: 300px;
  }

  .sky__mobile-smile {
    display: block;
    width: 40px;
    height: 40px;
    object-fit: contain;
  }

  .phrase {
    margin: 0;
    font-size: 15px;
    line-height: 1.6;
    text-wrap: balance;
  }

  .sky__planet {
    display: none;
    pointer-events: none;
    animation-name: sky_mobile_float;
    animation-duration: 14s;
  }

  .sky .sky__planet_3 {
    display: block;
    width: clamp(110px, 32vw, 180px);
    top: 12%;
    left: 3%;
    bottom: auto;
  }

  .sky .sky__planet_7 {
    display: block;
    width: clamp(110px, 32vw, 180px);
    right: -6%;
    top: initial;
    bottom: 20%;
  }

  .sky .sky__planet_11 {
    display: block;
    width: clamp(110px, 32vw, 180px);
    left: -6%;
  }

  .sky .sky__planet_6 {
    display: block;
    width: clamp(130px, 38vw, 210px);
    top: 24%;
    right: -8%;
    bottom: auto;
    animation-delay: -5s;
  }

  .sky .sky__planet_13 {
    display: block;
    width: clamp(90px, 26vw, 150px);
    left: -12%;
    bottom: 35%;
    animation-delay: -9s;
  }

}

@keyframes sky_mobile_float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-14px); }
}

@media screen and (max-width: 700px) and (prefers-reduced-motion: reduce) {
  .sky__planet {
    animation: none;
  }
}
</style>
